/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_massmol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Pick any mass, concentration and volume unit per field; conversions are handled internally and the result is shown in the unit you chose for the blank field.`)
};

const es_massmol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Elige cualquier unidad de masa, concentración y volumen por campo; las conversiones se gestionan internamente y el resultado se muestra en la unidad que elegiste para el campo en blanco.`)
};

const de_massmol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Wählen Sie pro Feld eine beliebige Massen-, Konzentrations- und Volumeneinheit; Umrechnungen erfolgen intern, und das Ergebnis wird in der für das leere Feld gewählten Einheit angezeigt.`)
};

const nl_massmol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Kies per veld een willekeurige massa-, concentratie- en volume-eenheid; omrekeningen gebeuren intern en het resultaat wordt getoond in de eenheid die je voor het lege veld hebt gekozen.`)
};

const fr_massmol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Choisissez n'importe quelle unité de masse, de concentration et de volume par champ ; les conversions sont gérées en interne et le résultat s'affiche dans l'unité choisie pour le champ vide.`)
};

const it_massmol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Scegli qualsiasi unità di massa, concentrazione e volume per ciascun campo; le conversioni vengono gestite internamente e il risultato viene mostrato nell'unità scelta per il campo vuoto.`)
};

const pt_br2_massmol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Escolha qualquer unidade de massa, concentração e volume por campo; as conversões são feitas internamente e o resultado é exibido na unidade escolhida para o campo em branco.`)
};

const pt_massmol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Escolha qualquer unidade de massa, concentração e volume por campo; as conversões são tratadas internamente e o resultado é apresentado na unidade escolhida para o campo em branco.`)
};

const ja_massmol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。各フィールドで任意の質量、濃度、体積の単位を選択できます。変換は内部で処理され、結果は空欄フィールドに選んだ単位で表示されます。`)
};

const zh_massmol_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。每个字段可任选质量、浓度和体积单位；内部会自动换算，结果以你为空白字段选择的单位显示。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const massmol_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.massmol_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("massmol_faq_a3", locale)
	if (locale === "en") return en_massmol_faq_a3(inputs)
	if (locale === "es") return es_massmol_faq_a3(inputs)
	if (locale === "de") return de_massmol_faq_a3(inputs)
	if (locale === "nl") return nl_massmol_faq_a3(inputs)
	if (locale === "fr") return fr_massmol_faq_a3(inputs)
	if (locale === "it") return it_massmol_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_massmol_faq_a3(inputs)
	if (locale === "pt") return pt_massmol_faq_a3(inputs)
	if (locale === "ja") return ja_massmol_faq_a3(inputs)
	return zh_massmol_faq_a3(inputs)
};